import type {SxProps} from '@mui/material';
import type {IconName} from 'components/icons/types';
import type {NodeAndAncestors} from 'services/thesaurus/types';
import {UnstyledButton} from 'components/button/UnstyledButton';
import {Icon} from 'components/icons';
import {Layout} from 'components/layout';
import {useThesaurusEditStateContext} from '../contexts';
import {ThesaurusNodePath} from './ThesaurusNodePath';

type Props = {
  node: NodeAndAncestors;
  prefixIcon?: IconName;
  /** Will highlight any matches in code and node label if set */
  searchQuery?: string;
  matchAllLevels?: boolean;
  noRightArrow?: boolean;
  sx?: SxProps;
  innerSx?: SxProps;
  onGotoNode: () => void;
};

export const ThesaurusNodeButton: React.FC<Props> = ({
  node,
  prefixIcon,
  noRightArrow = false,
  searchQuery,
  sx,
  innerSx,
  onGotoNode,
}) => {
  const {getDisplayCode} = useThesaurusEditStateContext();

  const code = getDisplayCode(node.node);

  return (
    <UnstyledButton onClick={onGotoNode}>
      <Layout horizontal adjustCenter justifyContent={'space-between'} sx={sx}>
        <ThesaurusNodePath
          node={node}
          prefixIcon={prefixIcon}
          code={code}
          searchQuery={searchQuery}
          pathSx={innerSx}
        />
        {!noRightArrow ? (
          <Icon icon={'ArrowRight'} sx={{cursor: 'pointer'}} />
        ) : null}
      </Layout>
    </UnstyledButton>
  );
};
